var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isLoading)?_c('div',{staticClass:"d-flex justify-content-center"},[_c('beat-loader',{attrs:{"loading":_vm.isLoading,"color":_vm.color,"size":_vm.size}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }